/**
 * Convierte una fecha en formato YYYY-MM-DD (o ISO completo) a DD/MM/YYYY.
 * Retorna cadena vacía si el valor es nulo o inválido.
 */
export function fmtFecha(val) {
  if (!val) return '';
  const s = String(val).substring(0, 10); // tomar solo la parte de fecha
  if (!/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
  const [y, m, d] = s.split('-');
  return `${d}/${m}/${y}`;
}
